/**
 * Wave 10 zod-mandate — runtime schemas for {@link nextBackoffMs}.
 *
 * @example
 * ```ts
 * import { BackoffOptionsSchema, BackoffAttemptSchema } from './Backoff.schema'
 * BackoffOptionsSchema.parse({ baseMs: 1000, maxMs: 60_000 })
 * BackoffAttemptSchema.parse(3)
 * ```
 */
import { z } from 'zod'

export const BackoffOptionsSchema = z
	.object({
		baseMs: z.number().nonnegative(),
		maxMs: z.number().nonnegative(),
		random: z.unknown().optional(),
	})
	.strict()

export const BackoffAttemptSchema = z.number().nonnegative()

export type BackoffOptionsInput = z.infer<typeof BackoffOptionsSchema>
